














































import {
  defineComponent, reactive, ref, watch,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import {
  updatePurchaseOrderItem,
  updatePurchaseOrderMiscItem,
} from '@/api';

import CommonTimeline from '@/components/PurchaseOrder/CommonTimeline.vue';

const NOW = useFormat.date().computerShortDate();

const CommonFormWithTargetDateUpdater = defineComponent({
  props: {
    value: {},
  },
  components: {
    CommonTimeline,
  },
  setup(props, { emit }) {
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();
    const type = ref('');
    const timeline = ref([]);
    const form = reactive({
      id: -1,
      name: '',
      code: '',
      date: NOW,
      amount: '0',
      oldDate: NOW,
      call: async () => {
        if (type.value === 'MATERIALS') {
          await updatePurchaseOrderItem(form.id, { amount: parseFloat(form.amount), targetDate: form.date });
        } else {
          await updatePurchaseOrderMiscItem(form.id, { amount: parseFloat(form.amount), targetDate: form.date });
        }
        emit('done');
      },
      state: {
        value: 'READY',
      },
    });
    function compose(option: any) {
      type.value = option.type || 'purchase_order_items';
      form.id = option.data.id;
      form.name = option.data.description;
      form.code = option.data.code || '';
      form.amount = parseFloat(option.data.amount || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      form.oldDate = option.data.target_date;
    }
    function close() {
      emit('close');
    }

    watch(() => props.value, (newVal, oldVal) => {
      if (newVal !== oldVal) compose(newVal);
    });

    return {
      toDate,
      compose,
      close,

      form,
      timeline,
    };
  },
});

export default CommonFormWithTargetDateUpdater;
